import { useState } from "react";
import OtherHeader from "../components/otherheader";
import { useNavigate } from "react-router";
import TrxOverview from "./components/TrxOverview";
import TrxTable from "./components/TrxTable";
import { useQueryState } from "nuqs";
import { useQuery } from "@tanstack/react-query";
import { getAllTransactions, getAllTransactionsAnalytics } from "../network/fetchers";
import { paginationData } from "../libs/constants";

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const Transactions = () => {
  const [sortByTimeFrame, setSortByTimeFrame] = useQueryState("timeFrame", {
    defaultValue: "month",
  });
  const [trxType, setTrxType] = useQueryState("trxType", {
    defaultValue: "",
  });
  const [trxStatus, setTrxStatus] = useQueryState("status", {
    defaultValue: "",
  });

  const [sortTrx, setSortTrx] = useQueryState("sort", {
    defaultValue: "recent",
  });
  const [selectedCountry, setSelectedCountry] = useQueryState("country", {
    defaultValue: "",
  });
  const [selectedAnalyticsCountry, setSelectedAnalyticsCountry] = useQueryState(
    "analyticsCountry",
    {
      defaultValue: "NGN",
    }
  );
  const isFilterActive =
    sortTrx !== "recent" ||
    selectedCountry.length ||
    trxStatus.length ||
    selectedAnalyticsCountry !== "NGN";

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  const debouncedSetSearch = debounce((value) => setSearch(value), 500);

  const { data: trxData, isLoading: loadingTrx } = useQuery({
    queryKey: [
      "transactions",
      trxType,
      currentPage,
      search,
      trxStatus,
      selectedCountry,
      sortTrx,
      search,
    ],
    queryFn: () =>
      getAllTransactions({
        page: currentPage,
        sort: sortTrx,
        type: trxType,
        status: trxStatus,
        currency: selectedCountry,
        q: search,
      }),
  });
  const { data: trxAnalytics, isLoading: loadingTrxAnalytics } = useQuery({
    queryKey: ["transactionsAnalytics", sortByTimeFrame, selectedAnalyticsCountry],
    queryFn: () =>
      getAllTransactionsAnalytics({
        period: sortByTimeFrame,
        currency: selectedAnalyticsCountry,
      }),
  });
  const trxMeta = trxData?.meta;

  const goToDetails = (items) => {
    navigate(`/transaction/home/${items._id}`, {
      state: {
        ...items,
      },
    });
  };

  const gotoPage = (requestedPage) => {
    return setCurrentPage(requestedPage);
  };

  return (
    <>
      <div className="">
        <OtherHeader title={"Transactions"} />

        <div className="info-cl2 ">
          <TrxOverview
            trxAnalytics={trxAnalytics || {}}
            isLoading={loadingTrxAnalytics}
            sortByTimeFrame={sortByTimeFrame}
            setSortByTimeFrame={setSortByTimeFrame}
            selectedAnalyticsCountry={selectedAnalyticsCountry}
            setSelectedAnalyticsCountry={setSelectedAnalyticsCountry}
          />
          <TrxTable
            trxType={trxType}
            setTrxType={setTrxType}
            trxStatus={trxStatus}
            setTrxStatus={setTrxStatus}
            sortTrx={sortTrx}
            setSortTrx={setSortTrx}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            currentTableData={trxData?.data || []}
            paginationData={paginationData(trxMeta?.totalPages)}
            activePage={trxMeta?.currentPage}
            isLoading={loadingTrx}
            setCurrentPage={setCurrentPage}
            isFilterActive={isFilterActive}
            debouncedSetSearch={debouncedSetSearch}
            search={search}
            setSearch={setSearch}
            setSelectedAnalyticsCountry={setSelectedAnalyticsCountry}
            hasNext={trxMeta?.hasNext}
            hasPrevious={trxMeta?.hasPrevious}
            gotoNext={() => {
              if (trxMeta?.totalPages === currentPage && !trxMeta?.hasNext) {
                return;
              }
              setCurrentPage((page) => page + 1);
            }}
            gotoPrev={() => {
              if (currentPage === 1 && !trxMeta?.hasPrevious) {
                return;
              }
              setCurrentPage((page) => page - 1);
            }}
            isDisabled={loadingTrx || !trxMeta?.hasNext || !trxMeta?.hasPrevious}
            goToDetails={goToDetails}
            gotoPage={gotoPage}
          />
        </div>
      </div>
    </>
  );
};

export default Transactions;
